import { Box, Center, Flex, Icon, Text, VStack } from '@chakra-ui/react';
import { IconType } from '@react-icons/all-files';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import { FaCommentDots } from '@react-icons/all-files/fa/FaCommentDots';
import { FaUsers } from '@react-icons/all-files/fa/FaUsers';
import { ReactNode } from 'react';

export type Step = {
  icon: IconType;
  title: string;
  desc: ReactNode;
  isActive?: boolean;
};

const STEPS: Step[] = [
  {
    icon: FaCheck,
    title: 'Your listing is live',
    desc: "It's visible to verified buyers in your area right now.",
  },
  {
    icon: FaUsers,
    title: 'Buyers are reviewing',
    desc: "Interested buyers are looking now and will send in offers when they're ready.",
  },
  {
    icon: FaCommentDots,
    title: "We'll reach out with offers",
    desc: "When offers come in, we'll text and email you so you can review them right here.",
  },
];

type WhatHappensNextStepsProps = {
  size?: 'sm' | 'md';
  steps?: Step[];
};

const SIZES = {
  sm: {
    circle: '32px',
    icon: '14px',
    title: '13px',
    desc: '12px',
    spacing: 3,
    gap: 3,
  },
  md: {
    circle: '40px',
    icon: '16px',
    title: '15px',
    desc: '13px',
    spacing: 4,
    gap: 4,
  },
} as const;

const WhatHappensNextSteps = ({ size = 'sm', steps = STEPS }: WhatHappensNextStepsProps) => {
  const sizeConfig = SIZES[size];

  return (
    <VStack spacing={sizeConfig.spacing} align="stretch">
      {steps.map((step) => (
        <Flex key={step.title} align="flex-start" gap={sizeConfig.gap}>
          <Center
            w={sizeConfig.circle}
            h={sizeConfig.circle}
            borderRadius="full"
            bg={step.isActive ? 'amberLight' : 'iceBlue'}
            color={step.isActive ? 'leaseEndBlue' : 'oceanBoatBlue'}
            flexShrink={0}
          >
            <Icon as={step.icon} boxSize={sizeConfig.icon} />
          </Center>
          <Box flex={1}>
            <Text fontSize={sizeConfig.title} fontWeight="700" color="grayDark" lineHeight="1.3">
              {step.title}
            </Text>
            <Box fontSize={sizeConfig.desc} color="grayLight" mt="2px">
              {step.desc}
            </Box>
          </Box>
        </Flex>
      ))}
    </VStack>
  );
};

export default WhatHappensNextSteps;
